export default __webpack_public_path__ + "static/media/naira.959c9214.svg";